module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/equipment01-4bf4ec07e39a629203ab5a49fa6a90a3.png";